module.exports = __webpack_public_path__ + "img/1.3e1b9740.jpg";